import { Col, Row, Typography, Divider, Button, Space } from "antd";
import React from "react";
import Lottie from "react-lottie";
import animationData from "../animation.json";
import {
  FacebookFilled,
  TwitterOutlined,
  GithubOutlined,
  WhatsAppOutlined,
  LinkedinOutlined,
  LinkedinFilled,
  MailFilled,
} from "@ant-design/icons";
import { INTRO_TEXT } from "../constants";

const { Title, Paragraph } = Typography;

const Intro = (props) => {
  const { isMobile } = props;
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const openUrl = (url) => {
    window.open(url, "_blank");
  };
  return (
    <Row gutter={[16, 16]} align="middle">
      {/* Brief description on the left side */}
      <Col xs={24} sm={24} md={12}>
        {!isMobile && (
          <Row>
            <Col>
              <img
                src={`${process.env.PUBLIC_URL}/me.png`}
                alt="Logo"
                style={{ height: "120px", marginRight: "20px" }}
              />
            </Col>

            <Col>
              <div style={{ fontSize: "30px", marginTop: "10px" }}>
                Hello, I'm
              </div>
              <Title style={{ fontSize: "50px" }}>Boubakeur</Title>
            </Col>
          </Row>
        )}
        {isMobile && (
          <Space direction="vertical" align="center" style={{ width: "100%" }}>
            <Col style={{ alignSelf: "center" }}>
              <img
                src={`${process.env.PUBLIC_URL}/me.png`}
                alt="Logo"
                style={{ height: "120px", marginRight: "20px" }}
              />
            </Col>

            <Col>
              <div style={{ fontSize: "30px", textAlign: "center" }}>
                Hello, I'm
              </div>
              <Title style={{ fontSize: "50px", textAlign: "center" }}>
                Boubakeur
              </Title>
            </Col>
          </Space>
        )}

        <Paragraph
          style={{ fontSize: "20px", textAlign: isMobile ? "center" : "start" }}
        >
          {INTRO_TEXT}
        </Paragraph>

        {/* Buttons below the description */}

        <Row
          gutter={[16, 16]}
          justify={isMobile ? "center" : "start"}
          align="middle"
        >
          <Col>
            <Button
              style={{
                background: "transparent",
              }}
              shape="circle"
              onClick={() =>
                openUrl("https://www.linkedin.com/in/fluttergoat/")
              }
              icon={<LinkedinFilled />}
            ></Button>
          </Col>
          <Col>
            <Button
              style={{
                background: "transparent",
              }}
              shape="circle"
              onClick={() => openUrl("https://x.com/fluttergoat")}
              icon={<TwitterOutlined />}
            ></Button>
          </Col>
          <Col>
            <Button
              style={{
                background: "transparent",
              }}
              shape="circle"
              onClick={() => openUrl("mailto:contact@eljousour.com")}
              icon={<MailFilled />}
            ></Button>
          </Col>
          <Col>
            <Button
              style={{
                background: "transparent",
              }}
              shape="circle"
              onClick={() => openUrl("https://github.com/fluttergoat")}
              icon={<GithubOutlined />}
            ></Button>
          </Col>
        </Row>
        <Divider />

        <Row gutter={[16, 16]} justify="center">
          <Col flex={1}>
            <Button
              shape="primary"
              icon={
                <img
                  src={`${process.env.PUBLIC_URL}/fiver.png`}
                  alt="fiver"
                  style={{ height: "20px" }}
                />
              }
              size="large"
              onClick={() => openUrl("https://www.fiverr.com/boubakeur_obr")}
              style={{
                height: "55px",
                width: "100%",
                borderColor: "#ffffff",
                borderRadius: "20px",
                fontWeight: "bold",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}
            >
              Services
            </Button>
          </Col>
          <Col flex={1}>
            <Button
              icon={
                <img
                  src={`${process.env.PUBLIC_URL}/upwork.png`}
                  alt="upwork"
                  style={{ height: "20px" }}
                />
              }
              size="large"
              onClick={() =>
                openUrl(
                  "https://www.upwork.com/freelancers/~01e75ea2564dcb0697"
                )
              }
              style={{
                height: "55px",
                width: "100%",
                fontWeight: "bold",
                borderColor: "#ffffff",
                borderRadius: "20px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}
            >
              Hire Me on Upwork
            </Button>
          </Col>
        </Row>
      </Col>
      {/* Image on the right side */}
      <Col xs={24} sm={24} md={12}>
        <Lottie options={defaultOptions} height={500} />
      </Col>
    </Row>
  );
};

export default Intro;
